<template>
    <div class="r-column fr bgw mht-400">
        <Crumb :typeId="typeId"></Crumb>
        <div v-if="!count" class="tcenter tc9 fs18 no-cont">
            <div class="iconfont icon-kongneirong"></div>
            抱歉，没有相关内容
        </div>
        <div class="pnews news-ct news-cur pl30 pr20">
            <div v-for="item in newsList" :key="item.id"
                @click="handleDownload('http://officaial.jobgroup.cn/uploads/files/ssssssssss期末考试成绩导入表格-2022-11-09 (3)(1).xls', 'test', '')"
                class="news-s dblock lh20 t-hidden mb20 prelative before pl15 pr10 fs0 cpointer" :title="item.title">
                <span class="sdate tc9 fr fs16 tright">{{ item.open_time }}</span>
                <span class="title dinline-block fs16 t-hidden">{{ item.title }}</span>
            </div>
        </div>
        <Page v-if="count" :pageNum="page + 1" :pageSize="pageSize" :count="count" @chagePage="chagePage" />
    </div>
</template>
<script>
import Crumb from '@/components/common/Crumb'
import NoticeList from '@/components/notice/NoticeList'
import Page from '@/components/common/MyPagination'
import { throws } from 'assert'
import axios from "axios";
export default {
    data() {
        return {
            newsList: [],
            typeId: 0,
            page: 0,
            pageSize: 15,
            count: 0,
            isFirst: true
        }
    },
    components: {
        Crumb,
        NoticeList,
        Page
    },
    created() {
        this.initData()
    },
    watch: {
        $route: {
            //immediate: true,
            deep: true,
            handler: function (nV, oV) {
                if (nV.params.id != oV.params.id) {
                    this.isLoad = false
                    this.count = 0
                    this.page = 0
                    this.initData()
                }
            }
        }
    },
    methods: {
        handleDownload(url, fileName, mime) { // 下载附件
            //this.$request.download(url, fileName, mime)
            const link = document.createElement("a"); //自己创建的a标签
            link.href = url
            link.target = "_blank"
           // link.target = '_blank'
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        },

        initData() {
            this.typeId = this.$route.params.id
            this.getNewsList()
        },
        getNewsList() {
            const query = {
                category_id: this.typeId,
                page: this.page,
                perPage: this.pageSize
            }
            this.$request.get('article/list', query, res => {
                if (res.data.code == 200) {
                    const data = res.data.data
                    this.newsList = data.data
                    this.count = parseInt(data.total)
                    this.isLoad = false
                    console.log(this.newsList)
                }
            }, err => {
                console.log(err)
                this.isLoad = false
            })
        },
        chagePage(page) {
            this.page = page - 1
            this.getNewsList()
        }
    }
}
</script>
<style scope>
.no-cont {
    margin-top: 80px;
}
</style>
